import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>,
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
